/**
 * Created by Gustavo on 13/06/2016.
 */

import {Injectable} from '@angular/core';
import { Http, RequestOptions, Response, Headers } from '@angular/http';
import {AuthHttpService} from './auth-http.service';
import {REST_PATHS}      from './rest-paths';
import { AuthSas, AuthHttpSas } from '../sas/index';
import { AuthState, AuthStatus }        from '../sas-models/index';
import { UserBean }              from '../beansts/index';
import {Observable}      from 'rxjs/Observable';
import { Observer }             from 'rxjs/Observer';
import { Subscription }         from 'rxjs/Subscription';
import { BehaviorSubject }      from 'rxjs/BehaviorSubject';
import {AppDataService} from "./app-data.service";
import * as firebase from 'firebase';
import {ContactBean} from "../beansts/contact.bean";
import {CompanyBean} from "../beansts/company.bean";
import {EventBean} from "../beansts/Event";
import { fromPromise } from 'rxjs/observable/fromPromise';
import * as CryptoJS from 'crypto-js';
declare var gapi: any;
//import GeoFire = require('geofire');
@Injectable()
export class UserService {




    constructor(private _authHttpService : AuthHttpService,private _auth : AuthSas,private _authHttp : AuthHttpSas,private _appData : AppDataService) {
      // Initialize Firebase



      var config = {
        apiKey: "AIzaSyBt_xy2toHw8Z31ItiZgPUnahcaHERfSr8",
        authDomain: "coolkids-669fa.firebaseapp.com",
        databaseURL: "https://coolkids-669fa.firebaseio.com",
        projectId: "coolkids-669fa",
        storageBucket: "coolkids-669fa.appspot.com",
        messagingSenderId: "159459566585"
      };
      try {
        firebase.initializeApp(config);
      }
      catch (err){
        //already connected
      }
    }

  public getLoggedUser(): Observable<any> {
    return  Observable.create((obs) => {
      return firebase.auth().onAuthStateChanged(
        (user) => obs.next(user),
        (err) => obs.error(err),
        () => obs.complete());
    });
  }
  
  removeFromFirestore(path:string){
    return firebase.storage().ref().child(path).delete();

  }
 
  // This method returns an ExamAuthState and emit a new ExamAuthState to
  // examAuthState stream observers
  // Any error is emitted
  public logoff(): Observable<any> {
    let promise = firebase.auth().signOut();
    let subscription =  Observable.fromPromise( <Promise<any>> promise );
    return subscription;

  }
  public getToken(email: string, password: string): Observable<any> {
    let promise = firebase.auth().signInWithEmailAndPassword( email , password );
    let subscription = Observable.fromPromise( <Promise<any>> promise );
    return subscription;
  }
  // This method returns an ExamAuthState and emit a new
  // ExamAuthState to examAuthState stream observers
  // Any error is emittednp
  public create(user: UserBean): Observable<any> {
    let promise = firebase.auth()
      .createUserWithEmailAndPassword(user.email, user.password);
    let subscription = Observable.fromPromise( <Promise<any>> promise );
    return subscription;
  }






  /**
   * @param Observable<number>
   */
  private progress$: Observable<number>;

  /**
   * @type {number}
   */
  private progress: number = 0;

  private progressObserver: any;



  /**
   * @returns {Observable<number>}
   */
  public getObserver (): Observable<number> {
    return this.progress$;
  }

 





  uploadImage(files: File[],filename: string) {
    var url:string;
      url = `${REST_PATHS.GET_USER}mediaSave`;
    let token : string = this._appData.token;
    var header="Authorization";
    var value="Bearer "+token;


    //this.setUploadUpdateInterval(500);
    return new Promise((resolve, reject) => {
      let formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            let d=new Date();
            let t:number=d.getTime();

            if (filename === 'userProfile') {
              this._appData.instagramUser.serverThumbnail = xhr.response+'?'+t;
            }

            else if (filename === 'companyIcon'){
              this._appData.company.companyIcon=xhr.response+'?'+t;
            }
            else if (filename === 'companyMainThumbnail'){
              this._appData.company.companyMainThumbnail=xhr.response+'?'+t;
            }
            else if (filename === 'companyMiddleThumbnail'){
              this._appData.company.companyMiddleThumbnail=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList1'){
              this._appData.company.companyThumbnailList1=xhr.response+'?'+t;
            }

            else if (filename === 'companyThumbnailList2'){
              this._appData.company.companyThumbnailList2=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList3'){
              this._appData.company.companyThumbnailList3=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList4'){
              this._appData.company.companyThumbnailList4=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList5'){
              this._appData.company.companyThumbnailList5=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList6'){
              this._appData.company.companyThumbnailList6=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList7'){
              this._appData.company.companyThumbnailList7=xhr.response+'?'+t;
            }
            else if (filename === 'companyThumbnailList8'){
              this._appData.company.companyThumbnailList8=xhr.response+'?'+t;
            }

          } else {
            reject(xhr.response);
          }

         }
      };

      for (let i = 0; i < files.length; i++) {
        var daa :Date=new Date();
        var tim=daa.getTime().toString();
        formData.append("file", files[i], filename);
        xhr.upload.onprogress = (event) => {
          this.progress = Math.round(event.loaded / event.total * 100);

          //    this.progressObserver.next(this.progress);
        };
        var finalurl:string =url+'?filename='+filename
        xhr.open('POST', finalurl, true);
        xhr.setRequestHeader(header,value);
        xhr.send(formData);
      }


    });

  }

  



  public blobToFile(theBlob: Blob, fileName:string): File {
    var b: any = theBlob;
    //A Blob() is almost a File() - it's just missing the two properties below which we will add
    b.lastModifiedDate = new Date();
    b.name = fileName;

    //Cast to a File() type
    return <File>theBlob;
  }
  public  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }
  }


  uploadToFirebaseWithBar(file: File, filename: string, path: string): Observable<any> {
  return new Observable(observer => {

    const storageRef = firebase.storage().ref().child(path + '/' + filename);
    const uploadTask = storageRef.put(file, {
      contentType: file.type
    });

    uploadTask.on(
      'state_changed',

      // 🔹 Progress
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

        observer.next({
          progress: progress,
          snapshot: snapshot
        });
      },

      // 🔹 Error
      (error) => {
        observer.error(error);
      },

      // 🔹 Complete
      () => {
        observer.complete();
      }
    );

  });
}
  uploadToFirebase(file: any, filename: string, path: string) {
    const name = filename;
    const metadata = {
      contentType: file.type
    };
    let subscription = fromPromise( <Promise<any>> firebase.storage().ref()
      .child(path+"/"+name)
      .put(file, metadata)
      .then());
    return subscription;

  }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/services/user.service.ts